/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */


import { HttpClient, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FORBIDDEN_ERR_MSG } from '../common/constants';
import { PropulsionEngDtl } from '../models/propulsion-eng-dtl.model';
import { ConfigService } from './config.service';
import { RemoveObsoleteRecordsService } from './remove-obsolete-records.service';

@Injectable({
  providedIn: 'root'
})

export class EngDtlService implements RemoveObsoleteRecordsService {
  constructor(private readonly configService: ConfigService,
              private readonly http: HttpClient) {
  }

  /**
   * Sends a get request to the specified API URL, which fetches the obsolete engine configurations
   * @return Observable<PropulsionEngDtl[]>
   */
  getObsoleteRecords(): Observable<PropulsionEngDtl[]> {
    return this.http.get<PropulsionEngDtl[]>(`${this.configService.baseApiUrl}eng-dtl/obsolete`).pipe(
      map((res) => res, catchError(myError => this.handleError(myError))));
  }

  /**
   * Sends a delete request to the specified API URL, which deletes the obsolete engine configurations from the database
   * @return any
   */
  removeObsoleteRecords(): any {
    return this.http.delete(`${this.configService.baseApiUrl}eng-dtl/delete-obsolete`).pipe(
      catchError(myError => this.handleError(myError)));
  }

  /**
   * Handles the errors produced by the backend
   * @param errorResponse The error produced by the API to be handled by the frontend
   * @return void
   */
  private handleError(errorResponse: HttpErrorResponse) {
    let errorMessage: string = 'An unexpected error occurred';
    switch (errorResponse.status) {
      case HttpStatusCode.BadRequest: {
        if (errorResponse.error && errorResponse.error.message) {
          errorMessage = errorResponse.error.message;
        } else {
          errorMessage = 'Remove Obsolete Engine Configurations failed.';
        }
        break;
      }
      case HttpStatusCode.Forbidden: {
        errorMessage = FORBIDDEN_ERR_MSG;
      }
    }
    return throwError(errorMessage);
  }
}
